module.exports = __webpack_public_path__ + "img/science-tab-2.5f8d5a5.png";